<template>
  <div id="left-sidebar">

    <ul class="left-nav-list list-unstyled">
      <router-link v-for="(item, index) in items" :to="item.alink" tag="li" active-class="active-link" :key='"menu" + index'>
        <!-- <svg class="icon pull-left" aria-hidden="true">
          <use :xlink:href="item.icon"></use>
        </svg> -->
        <img :class="item.icon" :src="'/static/img/dashboard/'+item.icon+'.svg'" alt="">
        <span>{{ item.title }}</span>
      </router-link>
    </ul>

  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  #left-sidebar {
    z-index: 3;
    padding-top: .4rem;
    position: fixed;
    top: .8rem;
    left: 0;
    min-height: 100%;
    background-color: #F7F7F7;
  }

  .left-nav-list {
    li {
      height: .6rem;
      line-height: .6rem;
      font-size: .14rem;
      letter-spacing: 0;
      color: #666;
      cursor: pointer;
      img {
        width: .2rem;
        height: .2rem;
      }
      .icon {
        height: .6rem;
        line-height: .6rem;
        font-size: .24rem;
        color: #666;
      }
      span {
        margin-left: .08rem;
      }
      &:hover, &.active-link {
        color: #111;
        background: #fff;
        img {
          &.ic_account {
            content: url(/static/img/dashboard/ic_account_hover.svg);
          }
          &.ic_settings {
            content: url(/static/img/dashboard/ic_settings_hover.svg);
          }
          &.ic_invitation {
            content: url(/static/img/dashboard/ic_invitation_hover.svg);
          }
          &.ic_recharge {
            content: url(/static/img/dashboard/ic_recharge_hover.svg);
          }
          &.ic_commission {
            content: url(/static/img/dashboard/ic_commission_hover.svg);
          }
          &.ic_device {
            content: url(/static/img/dashboard/ic_device_hover.svg);
          }
        }
      }
    }
  }

  @mixin pad-style() {
    .left-nav-list {
      li {
        padding: 0 .2rem;
      }
      span {
        display: none;
      }
    }
  }

  @mixin pc-style() {
    #left-sidebar {
      width: 2.2rem;
    }
    .left-nav-list li {
      padding: 0 0 0 .3rem;
    }
  }

  @media screen and (max-width: 767px) {
    #left-sidebar {
      display: none;
    }
  }

  @media screen and (max-width: 991px) {
    @include pad-style();
  }

  @media screen and (min-width: 992px) {
    @include pc-style();
  }
</style>

<script>
  import locales from './lang'
  import { mapState } from 'vuex'

  export default {
    name: 'left-sidebar-main',
    data: function () {
      return {
        isActiveChooseLang: false,
        items: [
          {title: this.$t('accountOverview'), icon: 'ic_account', alink: '/dashboard'},
          {title: this.$t('settings'), icon: 'ic_settings', alink: '/settings'},
          {title: this.$t('inviteRecord'), icon: 'ic_invitation', alink: '/affiliate'},
          {title: this.$t('rechargeRecords'), icon: 'ic_recharge', alink: '/recharge'},
          {title: this.$t('device_manage'), icon: 'ic_device', alink: '/device-management'}
        ]
      }
    },
    locales,
    computed: {
      ...mapState({
        nickName: state => state.user['nickname'],
        commissionApplyStatus: state => state.commission.commissionApplyStatus
      })
    },
    watch: {
      commissionApplyStatus() {
        if (this.commissionApplyStatus === 'complete') {
          this.items.splice(4, 0, {title: this.$t('affiliate'), icon: 'ic_commission', alink: '/commission'})
        }
      }
    },
    created: function () {
      if (window.localStorage.getItem('token') === null) {
        this.$router.replace('/login')
        return
      }
      if (this.commissionApplyStatus === 'complete') {
        this.items.splice(4, 0, {title: this.$t('affiliate'), icon: 'ic_commission', alink: '/commission'})
      }
    },
    methods: {
      signOut() {
        this.$store.dispatch('clearUserInfo')
        this.$router.replace('/')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// IndexMain.vue?895e4ac2